<template>
    <div class="app-alert-wrapper">
        <v-alert class="app-alert" :color="alertColor" text :dense="dense">
            <v-row class="app-alert__row" align="start" no-gutters>
                <v-col v-if="alertIcon" class="shrink">
                    <v-icon class="app-alert__icon" :color="alertColor" :size="iconSize">{{ alertIcon }}</v-icon>
                </v-col>
                <v-col class="grow">
                    <span class="app-alert__text">
                        <div v-if="!_.isNull(title)" :class="`text-h6 ${alertColor}--text text--darken-2`">
                            {{ title }}
                        </div>
                        <template v-if="findSlot('default')">
                            <slot />
                        </template>
                        <slot v-if="findSlot('text')" name="text" />
                        <p
                            v-else-if="!findSlot('default') && !_.isNull(text)"
                            :class="`mb-0 body-${smallText ? '2' : '1'} ${alertColor}--text text--darken-2`"
                        >
                            {{ textValue }}
                        </p>
                    </span>
                </v-col>
                <v-col class="shrink">
                    <div class="app-alert__action">
                        <slot name="action" />
                    </div>
                </v-col>
            </v-row>
        </v-alert>
    </div>
</template>

<script>
import alert from '@/mixins/alert';

export default {
    name: 'AppAlert',
    mixins: [alert],
    props: {
        icon: {
            type: String,
            default: null
        },
        iconSize: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'primary'
        },
        title: {
            type: String,
            default: null
        },
        text: {
            type: [String, Array],
            default: null
        },
        dense: {
            type: Boolean,
            default: false
        },
        smallText: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        textValue() {
            if (this._.isString(this.text)) {
                return this.text;
            }

            if (this._.isArray(this.text)) {
                return this.text.join('. ');
            }

            return null;
        }
    }
};
</script>
